import Network from '@/services/network'
import { ref } from 'vue'

export default function handleRegistration() {
    const network = new Network;
    const loading = ref(false)
    
    const registerUser = (data) => {
      return network.api('post', '/register', data);
    }

    const registerJobApplicantUser = (data) => {
        return network.api('post', '/job-applicant-register', data);
    }

    const otpVerifyUser = (data) => {
        return network.api('post', '/otp-verify', data);
    }

    const resendOtpUser = (data) => {
        return network.api('post', '/resend-otp', data);
    }
  
    return {
        registerUser,
        registerJobApplicantUser,
        otpVerifyUser,
        resendOtpUser,
        loading
    }
  }